import { Mixins, Component } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/exam';
import { ExamTypeEnum } from '@/libs/config';
import pageMixin from '../../../mixins/pageMixin';

@Component
export default class tableMixin extends Mixins(pageMixin) {
  private cList: any = [];

  private column: Array<ITABLECOLCONF> = [{
    label: '考试名称',
    prop: 'name',
    align: 'left',
    width: '150px',
    tooltip: true,
  }, {
    label: '考试时长(分钟)',
    prop: 'totalTime',
    align: 'left',
    width: '150px'
  }, {
    label: '描述',
    prop: 'description',
    align: 'left',
    tooltip: true,
  }, {
    label: '创建时间',
    prop: 'createAt',
    align: 'left',
    width: '150px',
  }, {
    label: '操作',
    custom: true,
    minWidth: '120px',
    align: 'center',
    maxBtn: 2,
    btnList: [
      // {
      //   title: '操作',
      //   name: '/course/info:chapter',
      //   icon: 'edit',
      //   type: 'info',
      //   callback: this.handleChapter,
      //   log: {
      //     name: '试题管理 - 操作',
      //     component: 'course/info/tableMixin',
      //   },
      // },
      {
        title: '修改',
        name: '/exam/info:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleEdit,
        log: {
          name: '考试管理 - 修改',
          component: '/exam/info:update',
        },
      },
      {
        title: '删除',
        name: '/exam/info:remove',
        icon: 'trash-o',
        type: 'info',
        callback: this.handleRemove,
        log: {
          name: '考试管理 - 删除',
          component: '/exam/info:remove',
        },
      },
    ],
  }]

  private loading: boolean = false;

  mounted() {
    // this.getData();
    this.getPageTest()
  }

  /**
   * @author liuyongchun
   * @desc 获取课程信息列表
   */
  // getData(params?: any) {
  //   this.loading = true;
  //   this.page.params = params;
  //   const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo, ...this.page.params };
  //   setTimeout(() => {
  //     const dataArray: Array<any> = Array.of();
  //     for (let i = 0; i < 5; i++) {
  //       dataArray.push({
  //         pid: i, examName: '考试'+i, examTime: 60+i, examDes: '描述'+i, createTime: '2020-10-11 20:02',
  //       });
  //     }
  //     this.cList = dataArray;
  //     this.total = dataArray.length;
  //     this.loading = false;
  //   }, 2000);
  // }

      // 查询所有考试
    // eslint-disable-next-line class-methods-use-this
    getPageTest() {
      const page = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        ...this.page.params
      };
      api.pageGetTest(page).then((res: any) => {
        this.cList = res.content
        this.total = res.totalElements;
      });
    }

  /**
   * @author liuyongchun
   * @desc 打开课程章节
   * @param { any } row 行数据
   */
  handleChapter(row: any) {
    this.$router.push({ name: 'course/chapter', params: { pid: Base64.encode(row.pid), type: 'Resource' } });
  }

  /* eslint-disable class-methods-use-this */
  handleEdit(row: any) {
    console.log(row);
  //   const data = {}
  //   api.modifyTest(data).then((res: any) => {
  //     console.log(res);
  //   })
  }

  /**
   * @author liuyongchun
   * @desc 删除正式课事件
   * @params { any } row 行数据
   */
  handleRemove(row: any) {
    this.confirm('你确定要删除该考试吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeTest(row.id).then(() => {
        this.getPageTest();
        close();
        this.$log({
          title: '考试管理 - 删除 - 确定',
          component: 'trial/manage/bModal',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '考试管理 - 删除 - 取消',
      component: 'trial/manage/bModal',
    }));
  }
}
